var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { dag } from "@hyper-hyper-space/hhs3_dag";
export class MemDagBackend {
    constructor(hash) {
        this.dags = new Map();
        this.entries = new Map();
        this.counter = 0;
        this.hash = hash;
    }
    getOrCreateDag(id, meta) {
        return __awaiter(this, void 0, void 0, function* () {
            const existing = this.dags.get(id);
            if (existing !== undefined) {
                return { dag: existing, created: false };
            }
            const dag = this.makeDag();
            this.dags.set(id, dag);
            this.entries.set(id, { id, type: meta.type, createdAt: ++this.counter });
            return { dag, created: true };
        });
    }
    openDag(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.dags.get(id);
        });
    }
    listDags() {
        return __awaiter(this, void 0, void 0, function* () {
            return [...this.entries.values()];
        });
    }
    makeDag() {
        const store = new dag.store.MemDagStorage();
        const index = dag.idx.flat.createFlatIndex(store, new dag.idx.flat.mem.MemFlatIndexStore());
        return dag.create(store, index, this.hash);
    }
}
